// removed by extract-text-webpack-plugin
module.exports = {"component":"_3B4vYHg08sKJG_Cw9nL3J2","control":"_2zQZHJEIYzCACKOLB7gdYy","header":"_39cx6vqFnTZM8HzoNjS8NU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LocationSwitcher/LocationSwitcher.css
// module id = 985
// module chunks = 0